import { createContext } from 'react';

const ExpressionContext = createContext({
  fields: {},
  fieldDefinitions: {},
  operatorDefinitions: {},
});

export default ExpressionContext;
